<template>
  <div>
    <section class="mt-5">
      <div class="container">
        <section class="content">
          <div class="row">
            <div class="col-md-10 mx-auto text-sm-start text-md-center">
              <p class="text-primary label-top">PETA PUSAKA</p>
              <h1 class="fw-bold">PETA PENYEBARAN SEKOLAH</h1>
              <hr width="50%" class="d-sm-block d-none mx-auto"/>
              <p>
                Berikut merupakan map yang telah kami sediakan dalam rangka memudahkan pengunjung melihat
                laporan yang telah dilaporkan dan juga melihat banyak peta sekolah di Jawa Barat
              </p>
              <a href="#" class="btn btn-outline-primary px-4 py-2">Jelajahi ▾</a>
            </div>
          </div>
        </section>
      </div>

      <div class="container mt-5">
        <div class="row">
          <div class="col-md-12 ">
            <div class="container">
<!--              <div class="loamding text-center col-md-12">-->
<!--                <div class="container"-->
<!--                     style="position: absolute;z-index: 3;background-color:rgba(255,255,255,0.5);margin-top:150px;">-->
<!--                  <div class="spinner-border mb-2" style="width: 50px; height: 50px;" role="status">-->
<!--                    <span class="visually-hidden">Loading...</span>-->
<!--                  </div>-->
<!--                  <p>Tunggu Sebentar...</p>-->
<!--                </div>-->
<!--              </div>-->
              <div class="dropdown-map">
                <div class="col-md-12" style="position: absolute;margin-top: 10px;padding-right: 45px;">
                  <div class="container">
                    <div class="row ms-auto">
                      <div class="col-md-3 ms-auto position-map">
                        <div class="form-group">
                          <select class="form-control" id="kabupaten">
                            <option>Kabupaten</option>
                          </select>
                        </div>
                        <div class="form-group">
                          <select class="form-control mt-2" id="kecamatan" style="display: none;">
                            <option value="">Kecamatan</option>
                          </select>
                        </div>
                        <div class="form-group">
                          <select class="form-control mt-2" id="desa" style="display: none;">
                            <option value="">Desa</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="map-section" id="mapid">

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import {latLng} from 'leaflet'
// import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'

export default {
  name: 'Peta',
  components: {
    // LMap,
    // LTileLayer,
    // LMarker,
  },
  data() {
    return {
      zoom: 20,
      center: latLng(-6.8454612, 107.6895576),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    }
  }
}
</script>

<style scoped>
#mapid {
  height: 400px;
}

.map-section {
  box-shadow:
    0 1.7px 1.7px rgba(0, 0, 0, 0.011),
    0 3.9px 3.9px rgba(0, 0, 0, 0.016),
    0 6.7px 6.7px rgba(0, 0, 0, 0.02),
    0 10.3px 10.3px rgba(0, 0, 0, 0.023),
    0 15.2px 15.2px rgba(0, 0, 0, 0.027),
    0 22.3px 22.3px rgba(0, 0, 0, 0.03),
    0 33.5px 33.5px rgba(0, 0, 0, 0.034),
    0 53.4px 53.4px rgba(0, 0, 0, 0.039),
    0 100px 100px rgba(0, 0, 0, 0.05);
}

@media (min-width: 992px) {
  .position-map{
    z-index: 999;
    background-color:rgba(255,255,255,0.5);
    padding: 10px;
    margin-right: 22vh;
  }
}

@media (min-width: 320px) and (max-width: 480px) {
  .position-map{
    z-index: 999;
    background-color:rgba(255,255,255,0.5);
    padding: 10px;
    margin-right: -4vh;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .position-map{
    z-index: 999;
    background-color:rgba(255,255,255,0.5);
    padding: 10px;
    margin-right: 7vh;
  }
}


</style>
